/* eslint-disable @typescript-eslint/no-explicit-any */

const authUrl = process.env.REACT_APP_AUTH_URL;
const applicationUrl = process.env.REACT_APP_REDIRECT_URL;

export const oidcConfig = {
  authority: authUrl,
  client_id: process.env.REACT_APP_AUTH_CLIENT_ID,
  redirect_uri: applicationUrl,
  scope: 'openid email profile',
  metadata: {
    issuer: authUrl,
    authorization_endpoint: `${authUrl}/oidc/oauth/authorize`,
    token_endpoint: `${authUrl}/oidc/oauth/token`,
    revocation_endpoint: `${authUrl}/oidc/oauth/revoke`,
    introspection_endpoint: `${authUrl}/oidc/oauth/introspect`,
    userinfo_endpoint: `${authUrl}/oidc/oauth/userinfo`,
    jwks_uri: `${authUrl}/oidc/oauth/discovery/keys`,
    scopes_supported: ['default', 'offline_access', 'openid', 'profile', 'email'],
    response_types_supported: ['code'],
    response_modes_supported: ['query', 'fragment', 'form_post'],
    grant_types_supported: ['authorization_code', 'refresh_token'],
    token_endpoint_auth_methods_supported: ['client_secret_basic', 'client_secret_post'],
    subject_types_supported: ['public'],
    id_token_signing_alg_values_supported: ['RS256'],
    claim_types_supported: ['normal'],
    claims_supported: ['iss', 'sub', 'aud', 'exp', 'iat', 'name', 'email', 'updated_at'],
  },
};
